import React from "react";
import propTypes from "prop-types";
import { map } from "lodash";
import intl from "react-intl-universal";
import { withRouter } from "react-router";

import { Link, SubMenu } from "../../index";
import { intlReplace } from "../../../utils/IntlReplace";
import { headerDatalayer } from "../../../utils/dataLayerPush";
import "./Navigation.scss";
// import ExpandableSearch from '../ExpandableSearch';

const Navigation = ({ accesses, userId, clientId, location }) => {
  const eventGTM = (label) => {
    headerDatalayer(
      "interaction",
      label.replace(/\s/g, "-").toLowerCase(),
      userId
    );
  };

  return (
    <nav className="vg-navigation">
      <ul>
        <li>
          <Link
            to="/"
            activeClassName="vg-link-active"
            exact
            onClick={() => eventGTM("inicio")}
          >
            {intl.get("NAVEGACAO.HOME")}
          </Link>
        </li>
        {map(accesses, (access, index) => (
          <li key={index}>
            {access.label === "relatorios" ? (
              <Link
                moveTo={access.label}
                onClick={() => eventGTM(access.label)}
              >
                {intl.get(`NAVEGACAO.${intlReplace(access.label)}`)}
              </Link>
            ) : (
              <div>
                <Link
                  to={`/${access.label}`}
                  activeClassName="vg-link-active"
                  onClick={() => eventGTM(access.label)}
                >
                  {intl.get(`NAVEGACAO.${intlReplace(access.label)}`)}
                </Link>
                {access.submenu && (
                  <SubMenu
                    label={access.label}
                    menuItens={access.submenu}
                    userId={userId}
                    clientId={clientId}
                  />
                )}
              </div>
            )}
          </li>
        ))}
        {location.pathname !== "/vagas" && (
          <a
            href={`${process.env.REACT_APP_ACCESS_CONTROL}/move-to/cadastrar-profissional?url_params=profissionais`}
            className="header-search-icon"
            aria-label={intl.get("NAVEGACAO.PESQUISA_CANDIDATOS")}
          >
            <box-icon name="search" aria-hidden />
          </a>
        )}
      </ul>
    </nav>
  );
};

Navigation.propTypes = {
  accesses: propTypes.array.isRequired,
  userId: propTypes.number.isRequired,
  clientId: propTypes.number.isRequired,
  location: propTypes.object,
};

Navigation.defaultProps = {
  accesses: [],
  userId: 0,
};

export default withRouter(Navigation);
